var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRzwsTour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "sprinkler-border",
    d: "M12 2 1 20h22z",
    fill: "#fff",
    stroke: "#3e4346",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6l7 12H5z",
    fill: "#529f40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRzwsTour);
export default __webpack_public_path__ + "static/media/rzws-tour.afcdf152b2c9e28e085dc392c40bd5f4.svg";
export { ForwardRef as ReactComponent };